import { createSlice } from '@reduxjs/toolkit';
export const purchaseInitialState = {
    products: [],
    error: null,
    loading: false,
    paymentRequired: false,
};
const purchaseSlice = createSlice({
    name: 'purchase',
    initialState: purchaseInitialState,
    reducers: {
        productUpdated(state, action) {
            const productIndex = state.products.findIndex((p) => p.id === action.payload.id);
            if (productIndex >= 0) {
                state.products[productIndex] = action.payload;
            }
            else {
                state.products.push(action.payload);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        purchaseApproved(state, action) {
            // Handle approved purchase
            state.loading = false;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        purchaseError(state, action) {
            state.error = action.payload.message;
            state.loading = false;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        startPurchase(state) {
            state.loading = true;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setPaymentRequired(state, action) {
            state.paymentRequired = action.payload;
        },
    },
});
export const { productUpdated, purchaseApproved, purchaseError, startPurchase, setPaymentRequired, } = purchaseSlice.actions;
export const purchaseReducer = purchaseSlice.reducer;
export default purchaseSlice;
